import { MODAL_CALLBACK_HIDE, MODAL_CALLBACK_SHOW } from "./../constants/constants";
import { NAM_COUNTRY_ID_NUMBER, SA_COUNTRY_ID_NUMBER } from "./../constants/internationalization";
import { CLAIMS_IN_THE_MEANTIME, OUR_REPAIRERS } from "./../routes/routes";
import { THEFT_WRITEOFF_CAR_COVER_TYPE, THIRDPARTY_CAR_COVER_TYPE, THIRDPARTY_FIRETHEFT_CAR_COVER_TYPE, THIRDPARTY_MOTORBIKE_COVER_TYPE, THIRDPARTY_THEFT_MOTORBIKE_COVER_TYPE, THEFT_MOTORBIKE_COVER_TYPE, COMPREHENSIVE_MOTORBIKE_COVER_TYPE, COMPREHENSIVE_CAR_COVER_TYPE, AGREED_VALUE_COVER_TYPE, CHILLI_CAR_COVER_TYPE } from './../constants/constants';
import { submitFNOLNotDriveable, addTraumaCouncelling } from "./../actions/claimSubmitActions";
import { navigateTo } from "./../actions/navigationActions";
import { fnolCallMeBack } from "./../actions/profileActions";

export const hideModal = () => {
    console.log('hideModal');
    return (dispatch) => {
        dispatch({
            type: MODAL_CALLBACK_HIDE,
        });
    }
}

export const showModalDrivableYesNonRegularDriver = () => {
    return (dispatch, getState) => {
        let hours = '08:00 - 17:00';
        if (getState().profile.countryId === NAM_COUNTRY_ID_NUMBER) { hours = '08:00 - 16:30'; }

        let body = `<p>1 of our claims consultants will call you within the next 4 business hours to find out more about the driver
            <br /><br />
            <strong>Business hours:</strong><br />
            Mondays to Fridays, ` + hours + `</p>`;

        dispatch({
            type: MODAL_CALLBACK_SHOW,
            modalProps: {
                titleImage: 'Images/OnlineQuotes/CarInsurance/Sprite/online-headphones-red.png',
                titleText: 'Notification submitted',
                body: body,
                okButtonText: 'Okay',
                okButtonEvent: () => {
                    dispatch(navigateTo(CLAIMS_IN_THE_MEANTIME));
                    dispatch(submitFNOLNotDriveable());
                },
                cancelButtonText: ''
            }
        });
    }
}

export const showModalDrivableCloseClaim = () => {
    return (dispatch, getState) => {
        let body = `<p>We’ll go ahead and close this claim. We can still assist you and request a quote from 1 of our approved repairers though</p>
                    <p className="mb-20px">Would you like us to tell you more about this</p>`;

        dispatch({
            type: MODAL_CALLBACK_SHOW,
            modalProps: {
                titleImage: './images/thumbs-up.svg',
                titleText: 'Thanks',
                body: body,
                okButtonText: 'Okay',
                okButtonEvent: () => {
                    window.open(OUR_REPAIRERS, "_blank");
                },
                cancelButtonText: 'No thanks'
            }
        });
    }
}

// Success submitted, without Follow-up questions
export const showModalDrivabeSuccessSubmitted = () => {
    return (dispatch, getState) => {
        let body = `<p className="mb-0px">We'll give you a call if we need more info. In the meantime, you can keep track of your claim progress.</p> `;

        dispatch({
            type: MODAL_CALLBACK_SHOW,
            modalProps: {
                titleImage: './Images/Checkmark.svg',
                titleText: 'Claim successfully submitted',
                body: body,
                okButtonText: 'Okay',
                okButtonEvent: () => {
                },
                cancelButtonText: ''
            }
        });
    }
}

// Success submitted, with Follow-up questions
export const showModalDrivabeSuccessSubmittedFollowUp = () => {
    return (dispatch, getState) => {
        let body = '';
        if (getState().claimSubmit.selectedRiskItem.productId.toUpperCase() === THIRDPARTY_FIRETHEFT_CAR_COVER_TYPE || getState().claimSubmit.selectedRiskItem.productId.toUpperCase() === THIRDPARTY_CAR_COVER_TYPE || getState().claimSubmit.selectedRiskItem.productId.toUpperCase() === THEFT_MOTORBIKE_COVER_TYPE || getState().claimSubmit.selectedRiskItem.productId.toUpperCase() === THIRDPARTY_MOTORBIKE_COVER_TYPE || getState().claimSubmit.selectedRiskItem.productId.toUpperCase() === THIRDPARTY_THEFT_MOTORBIKE_COVER_TYPE) {
            body = `<p className="mb-0px">
                Thanks for the claim information. 
                <br />
                <br />
                While we’re processing your claim, there’s some additional info we need if we receive a claim from a third party involved in the incident.
            </p>`;
        } else if (getState().claimSubmit.selectedRiskItem.productId.toUpperCase() === THEFT_WRITEOFF_CAR_COVER_TYPE) {
            body = `<p className="mb-0px">
                Thanks for the claim information. 
                <br />
                <br />
                While we’re busy processing your claim, there’s some additional info we need. If your car is written off and your claim is approved, this info will help us to try and recover your excess, if a third party is liable.
            </p>`;
        } else {
            body = `<p className="mb-0px">
                Thanks for the claim information. 
                <br />
                <br />
                While we’re processing your claim, there’s some additional info that we need. Without this info, we won’t be able to attempt a recovery of your excess if the third party is liable and your claim is approved.
            </p>`;
        }

        dispatch({
            type: MODAL_CALLBACK_SHOW,
            modalProps: {
                titleImage: './Images/Checkmark.svg',
                titleText: 'Claim successfully submitted',
                body: body,
                okButtonText: `Let's go`,
                okButtonEvent: () => {
                },
                cancelButtonText: ''
            }
        });
    }
}

export const showModalAddAnotherClaim = () => {
    return (dispatch, getState) => {
        let hours = '08:00 - 17:00';
        if (getState().profile.countryId === NAM_COUNTRY_ID_NUMBER) { hours = '08:00 - 16:30'; }

        let body = `<p>We’ll call you within the next 4 business hours to get more info
                <br />
                <br />
                <strong>Business hours:</strong><br />
                Mondays to Fridays, `+ hours + `</p>`;

        dispatch({
            type: MODAL_CALLBACK_SHOW,
            modalProps: {
                titleImage: 'Images/FNOL/frame.png',
                titleText: 'Submit claim relating to this incident',
                body: body,
                okButtonText: 'Okay',
                okButtonEvent: () => {
                    let fullName = getState().profile.name + ' ' + getState().profile.surname;
                    let message = `Digital claim submitted – client needs assistance submitting another claim for the same incident.`;
                    dispatch(fnolCallMeBack(fullName, getState().profile.cellphoneNumber, message, 'claims_consultant', false));
                },
                cancelButtonText: ''
            }
        });
    }
}

export const showModalTraumaAssist = () => {
    return (dispatch, getState) => {
        let hours = '08:00 - 17:00';
        if (getState().profile.countryId === NAM_COUNTRY_ID_NUMBER) { hours = '08:00 - 16:30'; }

        let body = `<p>1 of our trusted consultants will give you a call within the next 4 business hours to get more info from you
                <br />
                <br />
                <strong>Business hours:</strong><br />
                Mondays to Fridays, `+ hours + `</p>`;

        dispatch({
            type: MODAL_CALLBACK_SHOW,
            modalProps: {
                titleImage: 'Images/FNOL/heart-in-hand.png',
                titleText: `We’re here for you`,
                body: body,
                okButtonText: 'Call me back',
                okButtonEvent: () => {
                    let fullName = getState().profile.name + ' ' + getState().profile.surname;
                    let message = `Digital claim submitted – client has requested to be assisted with trauma counselling.`;
                    dispatch(fnolCallMeBack(fullName, getState().profile.cellphoneNumber, message, 'claims_consultant', false));
                    dispatch(addTraumaCouncelling());
                },
                cancelButtonText: ''
            }
        });
    }
}

export const showModalClaimAssistance = () => {
    return (dispatch, getState) => {
        let hours = '08:00 - 17:00';
        if (getState().profile.countryId === NAM_COUNTRY_ID_NUMBER) { hours = '08:00 - 16:30'; }

        let body = `<p>We’ll call you within the next 4 business hours to get more info
                <br />
                <br />
                <strong>Business hours:</strong><br />
                Mondays to Fridays, `+ hours + `</p>`;

        dispatch({
            type: MODAL_CALLBACK_SHOW,
            modalProps: {
                titleImage: 'Images/OnlineQuotes/CarInsurance/Sprite/online-headphones-red.png',
                titleText: '',
                body: body,
                okButtonText: 'Okay',
                okButtonEvent: () => {
                    let fullName = getState().profile.name + ' ' + getState().profile.surname;
                    let message = `Digital claim submitted – client requested callback regarding a claim.`;
                    dispatch(fnolCallMeBack(fullName, getState().profile.cellphoneNumber, message, 'claims_consultant', false));
                },
                cancelButtonText: ''
            }
        });
    }
}